import styled from 'styled-components'

export const ContainerQuestions = styled.div`
  margin: 30px 0;
`
